<template>
  <div class="wbench-log-table">
    <el-tabs v-model="activeName" type="card" v-if="childData.length > 0">
      <el-tab-pane
        :label="item.businessName"
        :name="index + ''"
        v-for="(item, index) in allData"
        :key="item.businessName"
      ></el-tab-pane>
    </el-tabs>
    <el-timeline v-if="allData[activeName] && allData[activeName].matterLogs.length > 0">
      <el-timeline-item
        v-for="(item, index) in allData[activeName].matterLogs"
        :key="index"
        :timestamp="genTitle(item)"
        placement="top"
      >
        <el-card>
          <!-- <p v-if="item.act">
            {{ item.starBracket }}{{ item.actUser }}{{ item.endBracket }}{{ item.middleSpan
            }}<span :class="[item.actClass]">{{ item.act }}</span
            >{{ item.endSpan }}
          </p> -->
          <p
            v-if="
              item.btnKey === 'transmit' ||
              item.btnKey === 'dispatch' ||
              item.btnKey === 'addMpders' ||
              item.btnKey === 'addadvise'
            "
          >
            {{ item.logMsg }}
          </p>
          <p v-if="!item.optionKey && !item.idea && item.act">
            {{ item.middleSpan }}<span :class="[item.actClass]">{{ item.act }}</span
            >{{ item.endSpan }}
          </p>
          <p v-else-if="item.idea">
            {{ item.idea }}
          </p>
          <p v-else-if="item.act">
            {{ item.starBracket }}{{ item.actUser }}{{ item.endBracket }}{{ item.middleSpan
            }}<span :class="[item.actClass]">{{ item.act }}</span
            >{{ item.endSpan }}
          </p>
          <p
            v-else-if="
              item.btnKey !== 'transmit' &&
              item.btnKey !== 'dispatch' &&
              item.btnKey !== 'addMpders' &&
              item.btnKey !== 'addadvise'
            "
          >
            {{ item.logMsg }}
          </p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <el-timeline v-else class="timeline-hide">
      <el-timeline-item>
        <el-card>
          <p>暂无日志</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import Api from "../../api/index";
import request from "../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import { dateFormat } from "../../util";
import btnKey2RegExp from "./metaData/btnKey2RegExp";

export default {
  name: "WbenchLogTable",
  props: {
    businessId: {
      type: [String, Number],
      default: ""
    },
    logType: {
      type: [String, Number],
      default: "all"
    }
  },
  data() {
    return {
      bid: "",
      filterText: "",
      sourceData: [],
      tableData: [],
      prefix: "",
      childData: [],
      activeName: "0",
      optionKeyMap: {
        agree: "同意 ",
        disagree: "不同意 "
      },
      btnKeyMap: {
        initial: "启动",
        send: "发送",
        save: "保存待发",
        edit: "修改",
        pause: "暂停",
        resume: "恢复",
        repeal: "撤销",
        terminate: "终止",
        remark: "备注",
        submit: "提交会签|提交",
        addadvise: "添加会签人",
        signature: "签收",
        dispatch: "转派",
        goto: "跳转",
        return: "退回",
        recall: "撤回",
        rollback: "回退",
        transmit: "转发",
        addMpders: "添加会签人员"
      }
    };
  },
  computed: {
    allData() {
      return [
        {
          businessName: "本流程",
          matterLogs: this.tableData
        },
        ...this.childData
      ];
    }
  },
  watch: {
    businessId: {
      async handler(val) {
        if (val) {
          this.prefix = getCookie("plt-api-route") || "";
          this.bid = val;
          this.sourceData = [];
          this.tableData = [];
          this.getTableData();
          this.getChildMatterLogLists();
        }
      },
      immediate: true
    }
  },
  methods: {
    /*获取事项日志列表*/
    async getTableData() {
      try {
        const { success, data, message } = await request({
          url:
            this.prefix +
            Api.getLogLists({
              businessId: this.bid,
              type: this.logType
            }),
          method: "get"
        });
        if (!success) {
          this.$message.error("获取事项日志列表失败:" + message);
          return false;
        }
        const temp = [];
        if (Array.isArray(data)) {
          data.forEach((item) => {
            item.createTime = dateFormat(item.createTime);
            const logMsg = item.logMsg;
            const addRegExp = btnKey2RegExp[item.btnKey];
            const reg = new RegExp(`^(【)([\\d\\D]+?)(】)(.*)(${addRegExp})(.*)`);
            const res = reg.exec(logMsg); // 分离出该项的操作人员, 动作
            // console.log(reg,logMsg,res);
            if (res) {
              item.starBracket = res[1];
              item.actUser = res[2];
              item.endBracket = res[3];
              item.middleSpan = res[4] || "";
              item.act = res[5];
              const actClassMap = {
                退回: "danger"
              };

              item.actClass = actClassMap[item.act] || "normal";
              item.endSpan = res[6] || "";
            }
            temp.push(item);
          });
        }
        this.sourceData = temp;
        this.tableData = temp;
        // console.log(this.tableData);
      } catch (error) {
        this.$message.error("获取事项日志列表失败:" + error);
      }
    },
    genTitle(item) {
      const options = this.optionKeyMap[item.optionKey] || this.btnKeyMap[item.btnKey] || "";
      if (options) {
        return `【${item.createUserName}】-${options}-${item.createTime}`;
      }
      return `【${item.createUserName}】${item.createTime}`;
    },
    /**
     * 子流程
     */
    async getChildMatterLogLists() {
      try {
        const { success, data, message } = await request({
          url:
            this.prefix +
            Api.getChildMatterLogLists({
              businessId: this.bid,
              type: this.logType
            }),
          method: "get"
        });
        if (!success) {
          this.$message.error("获取事项日志列表失败:" + message);
          return false;
        }
        const temp = [];
        if (Array.isArray(data)) {
          data.forEach((parentItem) => {
            parentItem.businessName = String(parentItem.childBusinessName).split("-").shift();
            parentItem.matterLogs = parentItem.childMatterLogs;
            if (Array.isArray(parentItem.childMatterLogs)) {
              parentItem.childMatterLogs.forEach((item) => {
                item.createTime = dateFormat(item.createTime);
                const logMsg = item.logMsg;
                const addRegExp = btnKey2RegExp[item.btnKey];
                const reg = new RegExp(`^(【)([\\d\\D]+?)(】)(.*)(${addRegExp})(.*)`);
                const res = reg.exec(logMsg); // 分离出该项的操作人员, 动作
                // console.log(reg,logMsg,res);
                if (res) {
                  item.starBracket = res[1];
                  item.actUser = res[2];
                  item.endBracket = res[3];
                  item.middleSpan = res[4] || "";
                  item.act = res[5];
                  const actClassMap = {
                    退回: "danger"
                  };

                  item.actClass = actClassMap[item.act] || "normal";
                  item.endSpan = res[6] || "";
                }
              });
            }
            temp.push(parentItem);
          });
        }
        this.childData = temp;
      } catch (error) {
        this.$message.error("获取事项日志列表失败:" + error);
      }
    }
    // handleClick() {}
  }
};
</script>

<style lang="scss" scoped>
.wbench-log-table {
  padding: 20px;
  //margin: 20px 0;
  span.danger {
    color: var(--szgc-element-danger-color);
    font-weight: bold;
  }
  span.normal {
    color: var(--szgc-element-primary);
    font-weight: bold;
  }
  .el-timeline {
    padding-left: 0;
    .el-card {
      padding-left: 1em;
    }
  }
  ::v-deep .el-timeline {
    .el-timeline-item {
      padding-bottom: 15px;

      .el-timeline-item__timestamp {
        color: var(--szgc-element-primary);
      }

      .el-card {
        .el-card__body {
          padding: 10px 5px;
          color: #606266;
        }
      }
    }

    &.timeline-hide {
      .el-timeline-item__wrapper {
        padding-left: 0;
      }
    }
  }
}
</style>

